import { sfetchJson } from 'Internals/sfetch';

async function getSubscriptionStats(portalUrl: string, subId: string) {
  const requestOptions: RequestInit = { credentials: 'include' };
  return await sfetchJson(`${portalUrl}/monitoring/standard/${subId}`, requestOptions);
}

async function getInvoiceData(portalUrl: string, subId: string) {
  const requestOptions: RequestInit = { credentials: 'include' };
  return await sfetchJson(`${portalUrl}/monitoring/invoicing/${subId}`, requestOptions);
}

export const MonitoringAPI = {
  getSubscriptionStats,
  getInvoiceData,
};
